module.exports = __webpack_public_path__ + "img/compang-logo-b.e97febee.png";